module.exports = __webpack_public_path__ + "img/camera_button_preRecording.19abf845.svg";